import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@kontentino/ui';
import { NOT_AVAILABLE } from 'app/modules/analytics/modules/performance/utils/getPerformanceMetricDisplay';

/**
 * The "not available" (`—`) metric placeholder, hoverable with an explanation
 * of why the value is missing. Inherits font size/weight/color from its parent.
 */
const MetricNotAvailable: FC = () => {
  const { t } = useTranslation();
  return (
    <Tooltip content={t('analyticsPerformance.metricNotAvailableTooltip')}>
      <span
        className="tw-decoration-grayscale-40 tw-cursor-help tw-underline tw-decoration-dashed tw-underline-offset-2"
        data-cy="analytics_metric-not-available"
      >
        {NOT_AVAILABLE}
      </span>
    </Tooltip>
  );
};

export default MetricNotAvailable;
